<template>
  <b-modal
    ref="modal"
    title="Nuevo aviso"
    size="lg"
    hide-footer
    lazy
    @show="onShown"
  >
    <div class="card">
      <form
        @submit.prevent="submit"
        ref="form"
        v-promise-btn="{ action: 'submit' }"
      >
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 form-group form-group-sm">
              <label for="periodo" class="label">Periodo</label>
              <input
                disabled
                class="form-control bg-white"
                style="cursor: text"
                type="month"
                id="periodo"
                name="periodo"
                v-model="periodo"
              />
            </div>
            <div class="col-12 col-md-6 form-group form-group-sm">
              <label for="fecha_aviso" class="label">Fecha de Aviso</label>
              <input
                class="form-control"
                type="datetime-local"
                id="fecha_aviso"
                name="fecha_aviso"
                v-model="fechaAviso"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12 form-group form-group-sm">
              <SelectorMotivos v-model="motivo" />
            </div>

            <div class="col-12 form-group form-group-sm">
              <label for="fecha_compromiso" class="label"
                >Fecha de Compromiso</label
              >
              <input
                class="form-control"
                type="date"
                id="fecha_compromiso"
                name="fecha_compromiso"
                v-model="fecha_compromiso"
              />
            </div>

            <div class="col-12">
              <div class="form-group">
                <label for="comentarios" class="label">Comentarios</label>
                <textarea
                  id="comentarios"
                  v-model="comentarios"
                  :class="`form-control
                  `"
                  name="comentarios"
                ></textarea>
                <!-- ${isComentarioOk ? ' is-valid ' : ''} -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <button
                  @click="closeModal"
                  type="button"
                  class="btn btn-danger"
                >
                  Cancelar
                </button>

                <button type="submit" class="btn btn-primary">Confirmar</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import { get } from "lodash-es";
import SelectorMotivos from "../Tickets/Historial/NuevoAviso/SelectorMotivos.vue";
import axios from "axios";

export default {
  name: "NuevoAvisoModal",

  beforeMount() {},
  data: () => ({
    fecha_compromiso: null,
    motivo: null,
    comentarios: "",
    fechaAviso: null,
  }),
  components: { SelectorMotivos },
  computed: {
    // isComentarioOk() {
    //   return !!this.comentarios;
    // },
    periodo: {
      get() {
        return this.$moment().format("YYYY-MM");
      },
    },
    fechaDeAviso() {
      if (this.fechaAviso) {
        const fechaHora = this.fechaAviso;
        return this.$moment(fechaHora).format("YYYY-MM-DD HH:mm");
      }
      return null;
    },
  },
  methods: {
    async submit() {
      if (!this.comentarios) {
        this.$msgBoxOk("Por favor, escriba un comentario");
        return;
      }

      const resp = await axios.post("/execute", {
        method: "CLI.CrearNuevoAvisoDePago",
        parameters: [
          {
            name: "id_ticket",
            value: this.$route.params.id_ticket,
          },
          {
            name: "id_motivo",
            value: this.motivo ? this.motivo.id_motivo : null,
          },
          {
            name: "fecha_iteracion",
            value: this.fechaDeAviso,
          },

          {
            name: "fecha_compromiso",
            value: this.fecha_compromiso,
          },
          {
            name: "comentarios",
            value: this.comentarios,
          },
        ],
      });
      if (get(resp.data, "ok", false)) {
        this.$msgBoxOk("Nuevo aviso creado");
        this.$emit("update");
        this.closeModal();

        this.$refs.modal.hide();
      } else {
        this.$msgBoxOk(resp.message);
      }
    },
    closeModal() {
      this.fecha_compromiso = null;
      this.motivo = null;
      this.comentarios = null;
      this.fechaAviso = null;
      this.$refs.modal.hide();
    },
    onShown() {
      this.fechaAviso = this.$moment().format("YYYY-MM-DD HH:mm");
    },
  },
};
</script>

<style scoped></style>
